import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ShowAllCoordinators,
  deleteUser,
} from "../../../../context/Slice/RegisterSlice";
import { ShowAllCoordinatorProfiles } from "../../../../context/Slice/CoordinatorManagementSlice";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
} from "@mui/material";
import CreateCoordinator from "./CreateCoordinator";
import Swal from "sweetalert2";
import "./CoordinatorManagement.css";

const CoordinatorManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const coordinators = useSelector(
    (state) => state.RegisterR.coordinators.coordinatorRole
  );
  const [isAdding, setIsAdding] = useState(false);
  const [selectedCoordinator, setSelectedCoordinator] = useState(null);
  const [filterStatus, setFilterStatus] = useState("active"); // Default to 'active'
  const [tabValue, setTabValue] = useState("active"); // Track the selected tab
  const [Language, setLanguage] = useState(null);
  const [updatedCoordinators, setUpdatedCoordinators] = useState([]);
  const [Allcordinators, setAllcordinators] = useState([]);

  // Fetch coordinators from the API using Redux action
  useEffect(() => {
    dispatch(ShowAllCoordinators());
  }, [dispatch]);

  useEffect(() => {
    // Dispatch the action to fetch coordinator profiles
    dispatch(ShowAllCoordinatorProfiles())
      .unwrap()
      .then((response) => {
        // Log the language field to the console
        if (response && response.ShowCoordinatorProfile) {
          setLanguage(response.ShowCoordinatorProfile);
          setAllcordinators(response.ShowCoordinatorProfile);
        }
      })
      .catch((error) => {
        console.error("Error fetching coordinator profiles:", error);
      });
  }, [dispatch]);

  console.log(coordinators)
  console.log(Allcordinators)

const updateCoordinator =   coordinators?.map((coordinator) => {
  // ✅ Find the corresponding stored coordinator by ID
  const storedData = Allcordinators?.find(
    (stored) => stored.Coordinators_ID === coordinator.id// ✅ Ensure matching type
  );

  console.log("Stored Data for Coordinator:", storedData); // Debugging check

  return {
    ...coordinator,
    number_of_events: storedData?.number_of_events, // ✅ No "N/A", since data exists

  };
}) || [];

console.log(updateCoordinator)

  const rows =
  updateCoordinator?.map((coordinator) => ({
      id: coordinator.id,
      firstName: coordinator.firstName,
      lastName: coordinator.lastName,
      email: coordinator.email,
      role: coordinator.role,
      role_type: coordinator.role_type || "N/A",
      mobile_number: coordinator.mobile_number,
      Verified: coordinator.Verified ? "Yes" : "No",
      OwnerCity: coordinator.Coordinator?.[0]?.City || "N/A",
      status: coordinator.status, // Add status field
      number_of_events: coordinator.number_of_events || 0,
    })) || [];

  const filteredRows = rows.filter((row) => {
    if (filterStatus === "all") {
      return true; // No filter, show all
    }
    return row.status === filterStatus; // Filter based on status
  });

  const columns = [
    { field: "id", headerName: "ID", width: 60 },
    { field: "firstName", headerName: "First Name", width: 150 },
    { field: "lastName", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "role", headerName: "Role", width: 150 },
    { field: "mobile_number", headerName: "Mobile", width: 150 },
    { field: "OwnerCity", headerName: "City", width: 120 },
    { field: "role_type", headerName: "Type", width: 100 },
    { field: "number_of_events", headerName: "No of Events", width: 95 },

    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <div>
          <Button
            variant="contained"
            className="fs-5"
            sx={{ marginRight: "8px" }}
            onClick={() => handleView(params.row)}
          >
            View
          </Button>
          <Button
            variant="contained"
            className="fs-5"
            color={params.row.status === "active" ? "error" : "success"}
            onClick={() => handleDelete(params.row.id, params.row.status)} // Correctly passing status
          >
            {params.row.status === "active" ? "Disable" : "Enable"}
          </Button>
        </div>
      ),
    },
  ];

    console.log(Allcordinators);


  const handleCreateCoordinator = () => {
    setIsAdding(true);
  };

  const handleFormClose = () => {
    setIsAdding(false);
    setSelectedCoordinator(null);
  };

  const handleView = (row) => {
    setSelectedCoordinator(row);
  };

  const handleDelete = (id, currentStatus) => {
    const isCurrentlyActive = currentStatus === "active";
    const actionText = isCurrentlyActive ? "Disable" : "Enable";
    const confirmButtonText = `Yes, ${actionText} it!`;
    const successMessage = `The Vendor has been ${
      isCurrentlyActive ? "disabled" : "enabled"
    }.`;

    Swal.fire({
      title: "Are you sure?",
      text: `${actionText} the Vendor data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmButtonText,
      customClass: {
        popup: "swal2-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUser(id)).then(() => {
          Swal.fire(`${actionText}d!`, successMessage, "success");
          dispatch(ShowAllCoordinators()); // Refresh the vendor list
        });
      }
    });
  };

  const HandleBack = () => {
    navigate("/admin-dashboard");
  };

  // Handle Tab Change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setFilterStatus(newValue); // Automatically set the filterStatus based on the selected tab
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="MuiDataGrid-toolbarContainer">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return (
    <React.Fragment>
      <Box
        sx={{ height: 400, width: "100%" }}
        id="Admin-Cordinatormanagement"
        className="data-grid-container"
      >
        {!isAdding && (
          <>
            <h2 className="heading">Coordinator Management</h2>
            {/* Back Button */}
            <Button
              variant="contained"
              color="secondary"
              onClick={HandleBack}
              sx={{ position: "absolute", top: "20px", left: "20px" }}
            >
              Back
            </Button>
            <Box
              display="flex"
              className="searchField"
              gap={60}
              justifyContent="center"
              mb="10px"
            >
              <Button
                type="submit"
                variant="contained"
                className="primary fs-4"
                onClick={handleCreateCoordinator}
              >
                Create New Coordinator
              </Button>
            </Box>

            {/* Tabs for filtering by Active/Inactive status */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                aria-label="status tabs"
              >
                <Tab label="Active Coordinators" value="active" />
                <Tab label="Inactive Coordinators" value="inactive" />
              </Tabs>
            </Box>

            <DataGrid
              rows={filteredRows || []} // Display coordinators fetched from Redux store
              columns={columns}
              pageSize={5}
              pageSizeOptions={[5, 10, 15]}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomToolbar }}
              sx={{
                "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                  fontSize: "14px", // Default font size for larger screens
                },
                "@media (max-width: 800px)": {
                  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                    fontSize: "12px", // Font size for smaller screens
                  },
                  "& .MuiDataGrid-cell": {
                    padding: "5px", // Reduce padding for smaller screens to make cells more compact
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontSize: "12px", // Ensure column header title is also reduced
                  },
                },
                "@media (max-width: 500px)": {
                  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                    fontSize: "12px", // Further reduce font size for very small screens
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontSize: "12px", // Reduce column header title font size
                  },
                  "& .MuiDataGrid-cell": {
                    padding: "1px", // Reduce padding even more for very small screens
                  },
                },
              }}
            />
          </>
        )}
        {isAdding && <CreateCoordinator handleFormClose={handleFormClose} />}
        <Dialog
          open={!!selectedCoordinator}
          onClose={handleFormClose}
          fullWidth
          maxWidth="md"
          PaperProps={{
            style: {
              maxWidth: "90%", // Adjust the width for responsiveness
              maxHeight: "80%", // Adjust the height for responsiveness
            },
          }}
        >
          <DialogTitle
            style={{
              fontSize: "2.5rem", // Default font size
              fontWeight: "bold",
            }}
          >
            Coordinator Details
          </DialogTitle>
          <DialogContent
            style={{
              fontSize: "1.6rem", // Default content font size
            }}
          >
            {selectedCoordinator && (
              <div>
                <p>
                  <strong>ID:</strong> {selectedCoordinator.id}
                </p>
                <p>
                  <strong>Name:</strong> {selectedCoordinator.firstName}{" "}
                  {selectedCoordinator.lastName}
                </p>
                <p>
                  <strong>Email:</strong> {selectedCoordinator.email}
                </p>
                <p>
                  <strong>Mobile:</strong> {selectedCoordinator.mobile_number}
                </p>
                <p>
                  <strong>City:</strong>{" "}
                  {selectedCoordinator.OwnerCity || "N/A"}
                </p>
                <p>
                  <strong>Type:</strong>{" "}
                  {selectedCoordinator.role_type || "N/A"}
                </p>
                <div>
                  <strong>Languages:</strong>{" "}
                  {Language && Language.length > 0 ? (
                    Language.filter(
                      (lang) => lang.Coordinators_ID === selectedCoordinator.id
                    ).map((lang, index, filteredArray) => {
                      let parsedLanguages;

                      // Check if lang.Languages is an array or a stringified JSON array
                      if (Array.isArray(lang.Languages)) {
                        parsedLanguages = lang.Languages;
                      } else {
                        try {
                          parsedLanguages = JSON.parse(lang.Languages);
                        } catch (error) {
                          parsedLanguages = [lang.Languages]; // Fallback for plain string
                        }
                      }

                      return (
                        <span key={index}>
                          {parsedLanguages.join(", ")}
                          {index !== filteredArray.length - 1 && ", "}
                        </span>
                      );
                    })
                  ) : (
                    <>No Languages</>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleFormClose}
              color="primary"
              style={{
                fontSize: "1rem",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </React.Fragment>
  );
};

export default CoordinatorManagement;
